// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5806690","400":"c50ad6d9","453":"0f5215d9","455":"2d65c486"}[chunkId] + ".chunk.js";
};